import React, { useCallback } from 'react'
import styled from 'styled-components'
import ApplicationData, { ApplicationDataFull } from '../../types/ApplicationData'
import Slider from '../components/slider/Slider'
import { useSelector } from '../store/hooks'
import { useApplication } from '../store/hooks/uiInspirationHooks'
import { device } from '../style'
import Stage from './Stage'

const Slide = styled.div<{ backgroundImage: { url: string } }>`
  height: 100%;
  background-image: url('${(props) => props.backgroundImage?.url}');
  background-size: cover;
  background-position: 57% 30%;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 0) 80%,
      rgba(0, 0, 0, 0.4)
    );
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.4));
  }

  @media ${device.laptop} {
    background-position: center 30%;

    &::before {
      background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
    }

    &::after {
      display: none;
    }
  }
`

const keyExtractor = (item: ApplicationData) => item.id

const ApplicationSlider: React.FC<{ className?: string }> = ({ className }) => {
  const { applications, index: currentSlide, lastMovement } = useApplication()
  const configurations = useSelector((state) => state.configuration.inspirationMode)
  const expertModeConfig = useSelector((state) => state.configuration.expertMode)
  const isExpertMode = useSelector((state) => state.ui.mode === 'expert')

  const renderItem = useCallback(
    (application: ApplicationDataFull) => (
      <Slide backgroundImage={application.backgroundImage} key={application.id}>
        <Stage
          application={application}
          configuration={isExpertMode ? expertModeConfig : configurations[application.id]}
        />
      </Slide>
    ),
    [configurations, expertModeConfig, isExpertMode]
  )

  return (
    <Slider
      className={className}
      items={applications}
      keyExtractor={keyExtractor}
      renderItem={renderItem}
      currentSlide={currentSlide}
      lastMovement={lastMovement}
    />
  )
}

export default ApplicationSlider
